<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="row mt-1">
    <div class="col-lg-4 offset-lg-4">
        <div class="card  mb-3" style="max-width: 25rem;">
            <div class="card-header text-center">{{ operacion }} Inscripción</div>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="addInscription()">
                    <table class="table">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                                <th>Duración</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr *ngFor="let career of careers" [class.selected]="career.id === form.get('idcareer')?.value" (click)="selectCareer(career)">
                                <td>{{ career.id }}</td>
                                <td>{{ career.name }}</td>
                                <td>{{ career.duration }}</td>
                            </tr>
                            
                        </tbody>
                    </table>
                    <table class="table mt-2">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                                <th>Apellido</th>
                                <th>CI</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let student of students" [class.selected]="student.id === form.get('idstudent')?.value" (click)="selectStudent(student)">
                                <td>{{ student.id }}</td>
                                <td>{{ student.name }}</td>
                                <td>{{ student.lastname }}</td>
                                <td>{{ student.ci }}</td>
                                <td>{{ student.status }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="row mt-2 text-center">
                        <div class="col-lg-6">
                            <button routerLink="/inscription" type="button" class="btn btn-secondary">Volver</button>
                        </div>
                        <div class="col-lg-6">
                            <button [disabled]="form.invalid" type="submit" class="btn btn-primary">Aceptar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
